import { render, staticRenderFns } from "./timeTJ.vue?vue&type=template&id=1409c83a&scoped=true&"
import script from "./timeTJ.vue?vue&type=script&lang=js&"
export * from "./timeTJ.vue?vue&type=script&lang=js&"
import style0 from "./timeTJ.vue?vue&type=style&index=0&id=1409c83a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409c83a",
  null
  
)

export default component.exports